import { lazy } from "react";

/** Route and heavy shell chunks — loaded on demand to reduce initial bundle size. */
export const LazyAuraDashboard = lazy(() => import("../components/aura-dashboard/AuraDashboard"));
export const LazyMapView = lazy(() => import("../components/inspection-overview/MapView"));
export const LazySitesTable = lazy(() => import("../components/inspection-overview/SitesTable"));
export const LazyPinnedSitesTable = lazy(() => import("../components/inspection-overview/PinnedSitesTable"));
export const LazySiteOperationsMain = lazy(
  () => import("../components/inspection-overview/site-operations/SiteOperationsMain")
);
export const LazySiteSummary = lazy(() => import("../components/asset-summary/SiteSummary"));
export const LazyCameraOperator = lazy(() => import("../components/asset-summary/CameraOperator"));
export const LazyVoluntaryMapView = lazy(() => import("../components/voluntary-surveys/MapView"));
export const LazyListView = lazy(() => import("../components/voluntary-surveys/ListView"));
export const LazyPinned = lazy(() => import("../components/voluntary-surveys/Pinned"));
export const LazyVSurveySiteOperationsMain = lazy(
  () => import("../components/voluntary-surveys/survey-details/VSurveySiteOperationsMain")
);
export const LazyUnderConstruction = lazy(() => import("../components/common/UnderConstruction"));
